package org.lennycodes.hldi.pages.admin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import org.jetbrains.compose.web.dom.Text
import org.lennycodes.hldi.backend.db_service.observeAuth


@Page("/admin")
@Composable
fun Admin() {

    val ctx = rememberPageContext()

    var isAuthenticated by remember {
        mutableStateOf<Boolean?>(null)
    }


    LaunchedEffect(Unit) {

        observeAuth { loggedIn ->

            console.log("Auth state: $loggedIn")

            isAuthenticated = loggedIn

        }

    }


    when(isAuthenticated) {

        true -> {

            AdminLayout {

                Users()

            }

        }


        false -> {

            ctx.router.navigateTo("/login")

        }


        null -> {

            Column(
                modifier = Modifier.fillMaxSize()
            ) {

                Text("Checking authentication...")

            }

        }

    }

}